import { render, staticRenderFns } from "./sub-head.vue?vue&type=template&id=1fb63f73&scoped=true&"
import script from "./sub-head.vue?vue&type=script&lang=js&"
export * from "./sub-head.vue?vue&type=script&lang=js&"
import style0 from "./sub-head.vue?vue&type=style&index=0&id=1fb63f73&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb63f73",
  null
  
)

export default component.exports